var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-layout',[_c('page-header',{attrs:{"breadcrumb":['阅读本', '借还柜控制']}}),_c('div',{style:({
      margin: '24px'
    })},[_c('div',{style:({ textAlign: 'right', marginBottom: '16px' })},[_c('el-button',{attrs:{"size":"small"},on:{"click":() => _vm.store.fetch()}},[_vm._v("刷新")])],1),(!_vm.list.items.length)?_c('el-empty',{attrs:{"description":"暂无数据"}}):_vm._e(),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.list.loading),expression:"list.loading"}],style:({
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 300px))',
        gap: '16px'
      }),attrs:{"element-loading-background":"rgba(255,255,255, 0)"}},_vm._l((_vm.list.items),function(it){return _c('div',{key:it.equId,style:({
          padding: '16px',
          background: '#fff',
          borderRadius: '6px'
        })},[_c('div',{style:({
            display: 'flex',
            alignItems: 'center',
            marginBottom: '8px'
          })},[_c('div',{style:({
              fontSize: '16px',
              fontWeight: '500',
              flex: 1
            })},[_vm._v(" "+_vm._s(it.equName)+" ")]),_c('el-tag',{style:({
              height: '20px',
              lineHeight: '18px'
            }),attrs:{"type":it.status === '01' ? 'success' : 'info'}},[_vm._v(" "+_vm._s(it.status === '01' ? '在线' : '离线')+" ")])],1),_c('div',{style:({
            color: '#555'
          })},[_vm._v(" 设备ID ")]),_c('div',[_vm._v(" "+_vm._s(it.equCode)+" ")]),_c('div',{style:({
            borderBottom: '1px solid #eaeaea',
            margin: '16px 0'
          })}),_c('div',{style:({
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '8px'
          })},[_vm._v(" 借阅功能 "),_c('el-switch',{attrs:{"value":it.terminalBorrow,"active-value":1,"inactive-value":0,"disabled":_vm.store.saving},on:{"change":val => {
                _vm.MessageBoxService.confirm({
                  message: val ? '确定开启借阅功能' : '确定关闭借阅功能？',
                  type: 'warning'
                }).then(() => {
                  _vm.store.setBorrow(it, val)
                })
              }}})],1),_c('div',{style:({
            display: 'flex',
            justifyContent: 'space-between'
          })},[_vm._v(" 归还功能 "),_c('el-switch',{attrs:{"value":it.terminalReturn,"active-value":1,"inactive-value":0,"disabled":_vm.store.saving},on:{"change":val => {
                _vm.MessageBoxService.confirm({
                  message: val ? '确定开启归还功能' : '确定关闭归还功能',
                  type: 'warning'
                }).then(() => {
                  _vm.store.setReturn(it, val)
                })
              }}})],1)])}),0)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }